<template>
  <div class="modal fade" id="sapsaleschannelconfigmodal" tabindex="-1" role="dialog" style="display: none;">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" id="close" class="close" data-dismiss="modal" aria-label="Close"><span
            aria-hidden="true">×</span></button>
          <h4 class="modal-title"><i class="fa fa-exchange mr-5"></i>{{'SapSaleschannelConfig' |
            translate}}</h4>
        </div>
        <div class="modal-body">
          <b-alert :show="alert.dismiss" dismissible :variant="alert.type">
            <h4>
              <i v-if="alert.type == 'success' || alert.type == 'warning' "class="icon fa fa-check"></i>
              <i class="icon fa fa-ban" v-else></i>
              {{'alert_'+alert.type | translate}}!</h4>
            {{alert.message}}
          </b-alert>
          <div class="input-group">
            <label for="sales_channel_name">{{'sales_channel_name' | translate}}</label>
            <input v-if="isNew!==true" type="text" class="form-control" id="sales_channel_name"
                   :placeholder="'sales_channel_name' | translate"
                   v-model="modalSalesChannelConfig.sales_channel_name" readonly="true"/>
            <select v-else v-model="modalSalesChannelConfig.sales_channel_id" class="form-control">
              <option class="normal" v-for="channel in salesChannels" :value="channel.id">
                <template v-if="channel.name === 'selfservice_schuhede'">
                  schuhede2.0-parent
                </template>
                <template v-else-if="channel.name === 'schuhede-selfservice_schuhede'">
                  schuhede2.0
                </template>
                <template v-else>
                  {{ channel.name }}
                </template>
              </option>
            </select>
          </div>
          <div class="input-group">
            <label for="payment_method">{{'payment_method' | translate}}</label>
            <input type="text" class="form-control" id="payment_method"
                   :placeholder="'payment_method' | translate"
                   v-model="modalSalesChannelConfig.payment_method">
          </div>
          <div class="input-group">
            <label for="delivery_country">{{'delivery_country' | translate}}</label>
            <input type="text" class="form-control" id="delivery_country"
                   :placeholder="'delivery_country' | translate"
                   v-model="modalSalesChannelConfig.delivery_country">
          </div>
          <div class="input-group">
            <label for="billing_country">{{'billing_country' | translate}}</label>
            <input type="text" class="form-control" id="billing_country"
                   :placeholder="'billing_country' | translate"
                   v-model="modalSalesChannelConfig.billing_country">
          </div>
          <div class="input-group">
            <label for="sap_cpd_code">{{'sap_cpd_code' | translate}}</label>
            <input type="text" class="form-control" id="sap_cpd_code"
                   :placeholder="'sap_cpd_code' | translate"
                   v-model="modalSalesChannelConfig.sap_cpd_code">
          </div>
          <div class="input-group">
            <label for="hkont">{{'hkont' | translate}}</label>
            <input type="text" class="form-control" id="hkont"
                   :placeholder="'hkont' | translate"
                   v-model="modalSalesChannelConfig.hkont">
          </div>
          <div class="input-group">
            <label for="saknr">{{'saknr' | translate}}</label>
            <input type="text" class="form-control" id="saknr"
                   :placeholder="'saknr' | translate"
                   v-model="modalSalesChannelConfig.saknr">
          </div>
          <div class="input-group">
            <label for="c4c_customer_id">{{'c4c_customer_id' | translate}}</label>
            <input type="text" class="form-control" id="c4c_customer_id"
                   :placeholder="'c4c_customer_id' | translate"
            v-model="modalSalesChannelConfig.c4c_customer_id">
          </div>
          <div class="input-group">
            <label for="paytype_name">{{'paytype_name' | translate}}</label>
            <input type="text" class="form-control" id="paytype_name"
                   :placeholder="'paytype_name' | translate"
                   v-model="modalSalesChannelConfig.paytype_name">
          </div>
          <div class="input-group">
            <label for="paytype">{{'paytype' | translate}}</label>
            <input type="text" class="form-control" id="paytype"
                   :placeholder="'paytype' | translate"
                   v-model="modalSalesChannelConfig.paytype">
          </div>
          <div class="input-group">
            <label for="billtype_order">{{'billtype_order' | translate}}</label>
            <input type="text" class="form-control" id="billtype_order"
                   :placeholder="'billtype_order' | translate"
                   v-model="modalSalesChannelConfig.billtype_order">
          </div>
          <div class="input-group">
            <label for="billtype_return">{{'billtype_return' | translate}}</label>
            <input type="text" class="form-control" id="billtype_return"
                   :placeholder="'billtype_return' | translate"
                   v-model="modalSalesChannelConfig.billtype_return">
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" id="confirmEdit" :disabled="errors.any()" class="btn btn-app btn-success"
                  @click="send()"><span class="fa fa-save "></span>{{'save' | translate}}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
    export default {
        props: [
            'modalSalesChannelConfig',
            'isNew',

        ],
        data() {
            return {
                alert: {},
                salesChannels: {}
            }
        },
        methods: {
            send() {
                if (!this.isNew) {
                    API.post('config/sap/saleschannels/update', this.modalSalesChannelConfig)
                        .then($res => {
                            this.alert = {
                                dismiss: 4,
                                type: 'success',
                                message: 'success',
                                icon: 'icon fa fa-ban',
                                show: true,
                            }
                        })
                        .catch(error => {
                            this.alert = {
                                dismiss: 4,
                                type: 'danger',
                                message: [error.response.data.message],
                                icon: 'icon fa fa-ban',
                                show: true,
                            }
                        })
                } else {
                    API.post('config/sap/saleschannels/save', this.modalSalesChannelConfig)
                        .then(res => {
                            this.alert = {
                                dismiss: 4,
                                type: 'success',
                                message: 'success',
                                icon: 'icon fa fa-ban',
                                show: true,
                            }
                        })
                        .catch(error => {
                            this.alert = {
                                dismiss: 4,
                                type: 'danger',
                                message: [error.response.data.message],
                                icon: 'icon fa fa-ban',
                                show: true,
                            }
                        })
                }
            },
        },
        mounted() {
            API.get('config/sap/getsaleschannels').then(res => {
                this.salesChannels = res.data;
            })
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/tools/Modals/SapSalesChannelConfigModal.vue